import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "E:\\workSpacke\\screening-sys\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\workSpacke\\screening-sys\\node_modules\\core-js\\modules\\es6.symbol.js";
import Vue from "vue";
import Cookies from "js-cookie";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";
import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";

//import i18n from './lang' // Internationalization
import "./icons"; // icon
import "./permission"; // permission control
import "./utils/errorLog"; // error log

import * as filters from "./filters"; // global filters

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)

import "./styles/swiper-3.4.2.min.css";
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
//import { mockXHR } from '../mock' // simulation data

// mock api in github pages site build
// if (process.env.NODE_ENV === 'production') { mockXHR() }
//import 'babel-polyfill'
// import VueSocketIO from "vue-socket.io"
// import socketio from 'socket.io-client'
import { throttle } from '@/utils';
// if (process.env.VUE_APP_MODE != 'xm' && process.env.VUE_APP_MODE != 'hb') {
//   const path = process.env.VUE_APP_SOCKET_PATH
//   const socket = new VueSocketIO({
//     debug: true,
//     connection: socketio(path, {
//       path: '',
//       transports: ['websocket'],
//     }),
//     //connection: path,
//     vuex: {
//       store,
//       actionPrefix: "SOCKET_", //为vuex设置的两个前缀
//       mutationPrefix: "SOCKET_"
//     }
//   })

//   Vue.use(socket)
//   store.$socket = socket.io
// }

// import qs from 'qs';
// Vue.prototype.$qs = qs;

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  //i18n: (key, value) => i18n.t(key, value)
});

// register global utility filters.
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.prototype.$throttle = throttle;
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'archive_history') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    var storage = {
      setItem: function setItem(k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};
import Introduction from '@/components/Introduction';
Vue.component('Introduction', Introduction);
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  //i18n,
  render: function render(h) {
    return h(App);
  }
});
import '@vant/touch-emulator';